import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 512 512">
    <title>Arrow Up</title>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="48"
      d="M112 244l144-144 144 144M256 120v292"
    />
  </SvgIcon>
);

export default Icon;
